<template>
  <div class="google-map">
    <div class="add-polygon" @click="addTrianglePaths">
      <slot name="add-polygon"></slot>
    </div>
    <div class="remove-polygon" @click="removePath">
      <slot name="remove-polygon"></slot>
    </div>
    <gmap-map ref="mapRef" :zoom="zoom" :center="center" :options="options" @zoom_changed="handleZoomChange" map-type-id="roadmap">
      <gmap-marker clickable="clickable" :key="`stations-${index}`" :icon="stationMarker(station)" :position="station.position" v-for="(station, index) in stations" @click="handleStationClick(station)"></gmap-marker>
      <gmap-marker clickable="clickable" :key="`rider-${index}`" :icon="riderMarker" :position="rider.position" v-for="(rider, index) in riders" @click="handleRiderClick(rider)"></gmap-marker>
      <gmap-polygon ref="polygon" :paths="paths" v-if="showPolygon" :editable="editable" :options="polygonOptions" @rightclick="handleClickForDelete" @paths_changed="updateEdited($event)"></gmap-polygon>
    </gmap-map>
  </div>
</template>

<script>
import { ZOOM } from '@/libs/enum'
import GmapPolygon from '@/mixins/GmapPolygon'

const TAIWAN_GEO = { lat: 23.583234, lng: 120.5825975 }

export default {
  mixins: [GmapPolygon],
  props: {
    stations: {
      type: Array,
      default: () => []
    },
    riders: {
      type: Array,
      default: () => []
    },
    center: {
      type: Object,
      default: () => TAIWAN_GEO
    },
    zoom: {
      type: Number,
      default: ZOOM.COUNTRY
    },
    options: {
      type: Object,
      default: () => ({})
    },
    editable: {
      type: Boolean,
      default: false
    },
    paths: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      polygonOptions: {
        fillColor: 'grey',
        strokeColor: 'green',
        strokeWeight: 1
      }
    }
  },
  computed: {
    showPolygon () {
      return this.paths.length > 0
    },
    riderMarker () {
      return '/user-icon.png'
    },
    showSiteStatusColor () {
      return this.options.showSiteStatusColor || false
    }
  },
  methods: {
    updataZoom (zoom) {
      this.$emit('update:zoom', zoom)
    },
    handleZoomChange (zoom) {
      this.updataZoom(zoom)
    },
    stationMarker (station) {
      if (!this.showSiteStatusColor) return '/station-normal.png'
      const { available, bikeRacks } = station
      const availableRate = available / bikeRacks

      const levels = {
        danger: 0.2,
        warning: 0.5
      }

      for (const level in levels) {
        if (availableRate <= levels[level]) return `/station-${level}.png`
      }

      return '/station-success.png'
    },
    handleStationClick (station) {
      this.$emit('selectStation', station)
    },
    handleRiderClick (rider) {
      this.$emit('selectRider', rider)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .google-map
    display flex
    flex-direction column
    height 100%

    &>>> .vue-map-container
      height 100%
</style>
